import * as Yup from 'yup';

import { getEmailValidator } from 'src/common/validation/email';
import { FIELD_IS_REQUIRED } from 'src/common/validation/errors';
import { getPhoneValidator, getSinglePhoneValidator } from 'src/common/validation/phone';
import { PHONE_EXT_MAX } from 'src/common/validation/validators';
import type { IContact } from 'src/types/IContact';
import type { IPaymentContact } from 'src/types/IPaymentContact';

export type IContactFormValues = IContact[];

const contactValidationSchema = Yup.object<IContactFormValues>({
  emailAddress: getEmailValidator().default(null),

  plainPhone: getPhoneValidator('plainPhone', 'cellPhone'),
  cellPhone: getPhoneValidator('cellPhone', 'plainPhone'),

  plainPhoneExt: Yup.string()
    .nullable()
    .max(...PHONE_EXT_MAX)
    .default(null),

  firstName: Yup.string().required(FIELD_IS_REQUIRED).default(null),
  lastName: Yup.string().required(FIELD_IS_REQUIRED).default(null),
});

export const contactsValidationSchema = Yup.array().of(contactValidationSchema);

export const paymentContactValidationSchema = Yup.object<IPaymentContact>({
  firstName: Yup.string().required(FIELD_IS_REQUIRED).default(null),
  lastName: Yup.string().required(FIELD_IS_REQUIRED).default(null),

  emailAddress: getEmailValidator().default(null),
  phoneNumber: getSinglePhoneValidator().required(FIELD_IS_REQUIRED),
});
